export const BASE_INDEX = -1
export const FIRST_INDEX = 0
